import { useLocation } from "react-router-dom";
import PATH from "../constants/routes";

type returnType = {
  urlPaths: string[];
  checkActive: (string) => "active" | "";
};
export default function useActivePath(): returnType {
  const urlParams = useLocation();
  const urlPaths: string[] = urlParams.pathname.split("/");

  const checkActive = (path) => {
    if (urlPaths[1] === path) {
      return "active";
    } else if (urlPaths[1] === "" && PATH.HOMEPAGE === path) {
      return "active";
    } else {
      return "";
    }
  };
  return { urlPaths, checkActive };
}
